
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wallet",
      function () {
        return require("private-next-pages/wallet.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wallet"])
      });
    }
  